import { render } from "./MobileKeyboard.vue?vue&type=template&id=fdb57c34&ts=true"
import script from "./MobileKeyboard.vue?vue&type=script&lang=ts"
export * from "./MobileKeyboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__